export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7530.0290a49d.jpg";